import React from 'react'
import '../../Styles/choose.css'

const Choose = () => {

  return (
    <>
      <section className='choose-us-section'>
        <div className='container'>
        <div className='row'>
        <div className='col-12 property-heading-col'>
              <h3>Why Choose Us</h3>
            </div>
        </div>
          <div className='row choose-us-row'>
           
            <div className='col-sm-12 col-md-6 col-lg-6 col-xl-3'>
              <div className='choose-main one'>
                <img src="/images/hand.png" alt="hand-icon" />
                <h6>Wide Range of Properties</h6>
                <p>Lorem Ipsum is simply dummy text  the printing and typesetting industry Lorem Ipsum has been.</p>
                <button>View All</button>
              </div>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-6 col-xl-3'>
              <div className='choose-main two'>
                <img src="/images/trust.png" alt="hand-icon" />
                <h6>Wide Range of Properties</h6>
                <p>Lorem Ipsum is simply dummy text  the printing and typesetting industry Lorem Ipsum has been.</p>
                <button>View All</button>
              </div>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-6 col-xl-3'>
              <div className='choose-main three'>
                <img src="/images/money.png" alt="hand-icon" />
                <h6>Wide Range of Properties</h6>
                <p>Lorem Ipsum is simply dummy text  the printing and typesetting industry Lorem Ipsum has been.</p>
                <button>View All</button>
              </div>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-6 col-xl-3'>
              <div className='choose-main four'>
                <img src="/images/map.png" alt="hand-icon" />
                <h6>Wide Range of Properties</h6>
                <p>Lorem Ipsum is simply dummy text  the printing and typesetting industry Lorem Ipsum has been.</p>
                <button>View All</button>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  )
}

export default Choose
